var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChevronLeft = function SvgChevronLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M11.018 14.043a.75.75 0 0 0 .024-1.06l-4.59-4.81a.25.25 0 0 1 0-.346l4.59-4.81a.75.75 0 1 0-1.085-1.035l-4.59 4.81a1.75 1.75 0 0 0 0 2.416l4.59 4.81c.286.3.761.31 1.06.024",
    clipRule: "evenodd"
  })));
};
export default SvgChevronLeft;